'use client'
const PHONE_NUMBER_REGEX = /^(\+[1-9]\d{1,14})?$/;

export { PHONE_NUMBER_REGEX };
